import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    targetFrameId: String,
  };

  update() {
    const targetFrame = document.getElementById(this.targetFrameIdValue);
    if (targetFrame) {
      targetFrame.src = this.urlValue;
    }
  }
}
